export enum Step {
    Reason = 'REASON',
    Success = 'SUCCESS'
}

export enum BlockReason {
    Lost = 'LOST',
    Stolen = 'STOLEN',
    Fraudulent = 'FRAUDULENT',
    Counterfeit = 'COUNTERFEIT',
}
